import React, { useEffect } from 'react';
import Avatar from '../Avatar/Avatar';
import cx from 'classnames';
import styles from './MiniUserDetail.module.scss';

const initClassNames = {
  containerClassName: '',
  avatarClassName: '',
  titleClassName: '',
};

const MiniUserDetail = ({ avatar, name, skipImage = false, classNames = initClassNames, size, oneLetterAcronym = true }) => {
  const { containerClassName, avatarClassName, titleClassName } = classNames;
  return (
    <div className={cx(styles.container, containerClassName)}>
      {skipImage ? null : (
        <Avatar
          image={avatar}
          title={name}
          size={size}
          className={cx(styles.avatar, avatarClassName)}
          oneLetterAcronym={oneLetterAcronym}
        />
      )}
      <p tabIndex={0} className={cx(styles.name, titleClassName)}>{name}</p>
    </div>
  );
};

export default MiniUserDetail;
